module.exports = __webpack_public_path__ + "static/media/porto_protocol2.25082753.jpg";